import { rateConditionZodObject } from "@@/shared/acquire/accommodation-rate-conditions";
import { accommodationRateOptionZodObject } from "@@/shared/acquire/accommodation-rate-option";
import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";
import {
    accommodationRateIdFactory,
    accommodationRateIdZodSchema,
} from "./accommodation-rate-id";

// Accommodation Rate
const accommodationRateZodObject = z.object({
    _id: accommodationRateIdZodSchema,
    _type: z.literal("ACCOMMODATION_RATE"),
    _createdAt: isoAndUnixZodSchema,

    //Status: paused???
    //Channel-details'

    appliesTo: z.array(resourceIdZodSchema),
    title: translatableZodSchema,
    options: z.array(accommodationRateOptionZodObject),

    //rate conditions - version
    conditions: z.array(rateConditionZodObject).optional(),
});

type AccommodationRate = z.infer<typeof accommodationRateZodObject>;

// Accommodation Rate Factory
const accommodationRateFactoryParamsZodObject = accommodationRateZodObject.omit(
    {
        _id: true,
        _type: true,
        _createdAt: true,
    },
);
type AccommodationRateFactoryParams = z.infer<
    typeof accommodationRateFactoryParamsZodObject
>;
const accommodationRateFactory = (params: AccommodationRateFactoryParams) => {
    const accommodationRate: AccommodationRate = {
        ...params,
        _id: accommodationRateIdFactory(),
        _type: "ACCOMMODATION_RATE",
        _createdAt: nowIsoAndUnix(),
    };
    return accommodationRate;
};

export {
    accommodationRateFactory,
    accommodationRateFactoryParamsZodObject,
    accommodationRateZodObject,
};
export type { AccommodationRate, AccommodationRateFactoryParams };
